module.exports = __webpack_public_path__ + "img/fig06.a6f0d9da.jpg";